module.exports = __webpack_public_path__ + "img/广州冷库.258b2af4.jpg";